<div class="wrtc-subscriber" #mediaWrapper [ngClass]="{'student-video-mute' :
  ((student.additionalInfo.video.isMuted || !student.additionalInfo.video.isProvided) && status === RoomConnectionState.ONLINE) || !isCurrentUserOnline}">
  <div class="videoColorCircle"
       *ngIf="whiteboard | isSharedWith:student.id"
       [ngStyle]="{'background-color': student.personalColor}"></div>
  <div class="unmute-fullscreen-hand-classroom d-flex justify-content-center align-items-center"
       *ngIf="status === RoomConnectionState.ONLINE">
    <div class="d-flex flex-column mx-1">
      <img src="assets/img/wrtc/speaker-off.svg" width="70" class="my-1" alt="Speaker Off"
           style="cursor: pointer"
           title="Click to enable AudioCheckManager"
           *ngIf="classroom.isRoomMutedBecauseOfCurrentUserBlockedMicAndCam" (click)="handleClassroomUnmuteButtonClick()">
      <img src="assets/img/wrtc/out-of-fullscreen.svg" width="70" class="my-1 send-wakeup"
           alt="Out of Fullscreen"
           title="Not engaged in class - click to 'wake up'"
           *ngIf="!student.additionalInfo.isInFullscreenMode && (localUser.accessType === AccessType.TEACHER || localUser.accessType === AccessType.SUPPORT || localUser.accessType === AccessType.OBSERVER)"
           #eyeIconElem (click)="sendWakeUpNotificationToStudent(eyeIconElem)">
    </div>
    <div class="student-raised-hand-on-video mx-1"
         *ngIf="localUser.accessType !== AccessType.STUDENT && student.additionalInfo.isHandRisen">
      <img class="student-raised-hand-icon my-1"
           title="Click to lower"
           [ngStyle]="{'cursor' : localUser.accessType === AccessType.OBSERVER ? 'default':'pointer'}"
           src="assets/img/wrtc/student-raised-hand.png" (click)="cancelRaiseHand()"
           alt="student raised hand">
    </div>
  </div>

  <div class="wrtc-subscriber-timer d-flex align-items-center justify-content-center"
       *ngIf="status === RoomConnectionState.PENDING && (localUser.accessType !== AccessType.STUDENT)">
    {{timer.valueInSeconds | secondsToTimerValue}}
  </div>
</div>

<div class="wrtc-subscriber-label-div d-flex align-items-center"
     [ngClass]="
       gameMode.isStarted &&
       student.additionalInfo.roomConnectionStatus !== RoomConnectionState.PENDING &&
       gameMode.participantsTeamIndexById[student.id] !== undefined ?
          'team_' + (gameMode.participantsTeamIndexById[student.id] + 1) :
          ''
    ">
  <!--network quality level element-->
  <!-- TODO - implement ng-class="remoteParticipantInfo.networkQualityClass"-->
  <div title="Signal strength"
       class="volumebar-wrap d-flex mr-2"
       [ngClass]="'vol-' + student.additionalInfo.networkQualityLevel"
       *ngIf="(localUser.accessType === AccessType.TEACHER || localUser.accessType === AccessType.SUPPORT) &&
            status === RoomConnectionState.ONLINE">
    <div class="volume-strip strip-1"></div>
    <div class="volume-strip strip-2"></div>
    <div class="volume-strip strip-3"></div>
    <div class="volume-strip strip-4"></div>
    <div class="volume-strip strip-5"></div>
  </div>

  <div class="wrtc-subscriber-label text-truncate">
    {{student.displayName}}
  </div>

  <div class="d-flex align-items-center ml-auto"
       *ngIf="status === RoomConnectionState.ONLINE && (localUser.accessType === AccessType.TEACHER || localUser.accessType === AccessType.SUPPORT)">
    <span class="wb-indicator mr-2" *ngIf="(assignment.allowedSwitchingUsers?.has(student.id) || assignment.allowedSwitchingUsers?.size === 0)
                                          && assignment.isLoaded
                                          && student.additionalInfo.currentSelectedTab === ViewPortTabsIndexes.WHITEBOARD">
    </span>

    <button type="button" class="unanswered-message mr-2" style="z-index: 100;"
            title="{{student.additionalInfo.hasUnansweredMessage ? 'Unread message': 'No new messages'}}"
            [ngClass]="{'active': student.additionalInfo.hasUnansweredMessage}"
            (click)="manuallyHideUnansweredMessageIcon()">
      <i class="fas fa-comment-dots"></i>
    </button>
    <app-user-action-panel
      [remoteUser]="student"
      [userIndex]="userIndex"
      [isOpenedFromList]="false"
      [studentsCount]="studentsCount">
    </app-user-action-panel>
  </div>
</div>


<div class="wrtc-subscriber-controls d-flex flex-column" *ngIf="localUser.accessType === AccessType.STUDENT">
  <!--mute audio button-->
  <button class="video-action-btn wrtc-subscriber-sound-btn wrtc-button-push audio-button-muted active" type="button"
          style="cursor: default"
          *ngIf="student.additionalInfo.roomConnectionStatus === RoomConnectionState.ONLINE && (student.additionalInfo.audio.isMuted || !student.additionalInfo.audio.isProvided)">
    <i class="fas fa-microphone"
       [ngClass]="{'fa-microphone-slash':student.additionalInfo.audio.isMuted || !student.additionalInfo.audio.isProvided}"></i>
  </button>
</div>

<div class="wrtc-subscriber-controls d-flex flex-column"
     *ngIf="localUser.accessType !== AccessType.STUDENT && status === RoomConnectionState.ONLINE">
  <!--mute video button-->
  <button title="Camera on/off" class="video-action-btn wrtc-subscriber-webcam-btn" type="button"
          (click)="toggleVideoMute()"
          [ngClass]="{'wrtc-button-push video-button-muted active': student.additionalInfo.video.isMuted || !student.additionalInfo.video.isProvided}"
          [ngStyle]="{'cursor' : localUser.accessType === AccessType.OBSERVER ? 'default':'pointer'}"
          [disabled]="!student.additionalInfo?.video.isProvided">
    <i class="fas fa-video" [ngClass]="{'fa-video-slash':student.additionalInfo.video.isMuted || !student.additionalInfo.video.isProvided}"></i>
  </button>

  <!--mute audio button-->
  <button title="Microphone on/off" class="video-action-btn wrtc-subscriber-sound-btn" type="button"
          [disabled]="!student.additionalInfo.audio.isProvided"
          [ngStyle]="{'cursor' : localUser.accessType === AccessType.OBSERVER ? 'default':'pointer'}"
          (click)="toggleAudioMute()"
          [ngClass]="{'wrtc-button-push audio-button-muted active': student.additionalInfo.audio.isMuted || !student.additionalInfo.audio.isProvided}">
    <i class="fas fa-microphone"
       [ngClass]="{'fa-microphone-slash':student.additionalInfo.audio.isMuted || !student.additionalInfo.audio.isProvided}"></i>
  </button>

  <button class="video-action-btn private-talk" (click)="toggleJoinPrivateTalk()"
          title="Private Talk"
          [disabled]="!(student | canEnterPrivateTalk)"
          [ngClass]="{'private-talk-engaged on' : isPrivateTalkParticipant}"
          *ngIf="(localUser.accessType === AccessType.TEACHER || localUser.accessType === AccessType.SUPPORT)
     && status === RoomConnectionState.ONLINE"><i class="fas fa-phone-alt"></i></button>
</div>
<!--voice meter -->
<!-- TODO - implementy   value="{{remoteParticipantInfo.audio.level}}"-->
<meter class="voice-meter mt-auto" *ngIf="(localUser.accessType === AccessType.TEACHER || localUser.accessType === AccessType.SUPPORT)
   && status === RoomConnectionState.ONLINE" value="{{voiceMeterLevel}}"></meter>

<!--star container -->

<div class="star-container d-flex"
     *ngIf="isCurrentUserOnline && student.additionalInfo.roomConnectionStatus === RoomConnectionState.ONLINE && student.additionalInfo.stickers.length > 0">
            <span *ngFor="let sticker of student.additionalInfo.stickers"
                  class="sticker-icon" [ngClass]="'sticker-' + sticker">
              <img title="{{sticker}}"
                   alt="{{'Sticker ' + sticker}}"
                   [ngClass]="'sticker-' + sticker"
                   [src]="'assets/img/stickers/12x12/' + sticker + '-icon.png'">
            </span>
</div>
